import React, {useMemo, useState, useEffect} from "react";
import objectPath from "object-path";
import {useHtmlClassService} from "../../_core/MetronicLayout";
import {Topbar} from "./Topbar";
import {HeaderMenuWrapper} from "./header-menu/HeaderMenuWrapper";
import {AnimateLoading} from "../../../_partials/controls";

export function Header() {
  const uiService = useHtmlClassService();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 80);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const layoutProps = useMemo(() => {
    return {
      headerClasses: uiService.getClasses("header", true),
      headerAttributes: uiService.getAttributes("header"),
      headerContainerClasses: uiService.getClasses("header_container", true),
      menuHeaderDisplay: objectPath.get(
        uiService.config,
        "header.menu.self.display"
      )
    };
  }, [uiService]);

  return (
    <>
      <style>{`
        #kt_header.header-compact {
          min-height: 50px !important;
          height: 50px !important;
        }
        #kt_header.header-compact img,
        #kt_header.header-compact svg {
          max-height: 28px !important;
        }
        #kt_header.header-compact .menu-text,
        #kt_header.header-compact .topbar-item .text-light,
        #kt_header.header-compact .topbar-item span {
          font-size: 0.85rem !important;
        }
        #kt_header.header-compact .menu-link {
          padding-top: 4px !important;
          padding-bottom: 4px !important;
        }
        #kt_header { transition: height 0.15s ease, min-height 0.15s ease; }
      `}</style>
      {/*begin::Header*/}
      <div
      style={{width:"100%",right:"auto"}}
        className={`${window.location.pathname.split('/').slice(1)[0] == "my-korek" ?`header mx-0 centerFixed ${layoutProps.headerClasses}`:`header mx-0 centerFixed ${layoutProps.headerClasses}`} ${scrolled ? "header-compact" : ""}`}
        id="kt_header"
        {...layoutProps.headerAttributes}
      >
        {/*begin::Container*/}
        <div className={` ${layoutProps.headerContainerClasses} d-flex align-items-stretch maxWidthCont justify-content-between`}>
          <AnimateLoading />
          {/*begin::Header Menu Wrapper*/}
          {layoutProps.menuHeaderDisplay && <HeaderMenuWrapper />}
          {!layoutProps.menuHeaderDisplay && <div />}
          {/*end::Header Menu Wrapper*/}

          {/*begin::Topbar*/}
          <Topbar />
          {/*end::Topbar*/}
        </div>
        {/*end::Container*/}
      </div>
      {/*end::Header*/}
    </>
  );
}
